// src/components/modal/modal-tokens.ts

/**
 * Sensible defaults seeded from existing modals (ConfirmationModal, IRSInfoSheet).
 * Individual modals can override specific values (e.g. `maxWidth`) as needed.
 */
export const modalTokens = {
  backdropColor: 'rgba(0,0,0,0.5)',
  radius: 20,
  webMaxWidth: 480,
  /**
   * Breathing room kept between a focused input and the top of the keyboard.
   * Enough that the field is comfortably clear rather than flush against the
   * keyboard, which reads as "just barely visible".
   */
  keyboardBottomOffset: 24,
  surfaceMaxHeight: '85%',
  screenMargin: 20, // gap between the centered card and the screen edges (both platforms)
  actionGap: 8,
  actionMinHeight: 48,
  header: { paddingHorizontal: 20, paddingTop: 18, paddingBottom: 14 },
  body: { paddingHorizontal: 20, paddingTop: 8, paddingBottom: 24 },
  footer: { paddingHorizontal: 20, paddingTop: 12, paddingBottom: 12 },
} as const;
